export const sanitizeDecimalInput = (value: string): string => {
  if (!value) {
    return value;
  }

  let cleaned = value
    .replace(/[^0-9.]/g, '') // только цифры и точка
    .replace(/(\..*)\./g, '$1'); // одна точка

  if (cleaned.startsWith('.')) {
    cleaned = '0' + cleaned;
  }

  return cleaned;
};
